export default {
  terms: {
    title: '服务条款',
    effectiveDate: '生效日期：2024 年 3 月 15 日',
    intro:
      '欢迎使用 PhotoScope。PhotoScope 是一款由 AI 驱动的视觉学习工具，帮助你通过「自己的照片」与「你选择的参考图」之间的对比，理解一张照片的视觉风格，并解释两者差异、给出属于你自己的后期调整方向。本《服务条款》（以下简称「条款」）说明你在使用 PhotoScope 时的权利与责任。',
    sections: [
      {
        heading: '1. 条款的接受',
        body: [
          '注册账号或使用 PhotoScope，即表示你同意受本条款及《隐私政策》约束。如不同意，请勿使用本服务。',
        ],
      },
      {
        heading: '2. 服务说明',
        body: [
          'PhotoScope 让你上传一张照片并选择一张参考图。我们会分析两者之间的视觉差距（例如影调、色彩、饱和度与构图），并给出由 AI 生成的解释与调整建议。',
          'PhotoScope 是一款用于学习与理解的工具。它旨在帮助你理解摄影、建立自己的判断力，而不是自动修图工具、精修服务，也不保证任何结果都能复刻参考图。',
          '我们可能持续更新功能、模型与分析方法。预览、图表与建议均用于学习目的，可能随时变更且不另行通知。',
        ],
      },
      {
        heading: '3. 使用资格',
        body: [
          '你须年满 13 周岁方可使用 PhotoScope。使用本服务即表示你声明并保证符合该年龄要求，并具备同意本条款的能力。',
        ],
      },
      {
        heading: '4. 账号与第三方登录',
        body: [
          '你可以使用邮箱注册 PhotoScope 账号，或通过 Google 等第三方服务商登录。如使用第三方登录，你的使用行为同时受该服务商条款约束。',
          '你有责任妥善保管账号凭据，并对账号下发生的全部活动负责。如怀疑账号被盗用，请立即通知我们。',
        ],
      },
      {
        heading: '5. 积分与计费',
        body: [
          'PhotoScope 的部分功能采用积分制。你的账号可能包含免费积分以及你购买的积分。',
          '一次性购买的积分设有有效期，购买时及你的 Dashboard 中均会显示。未使用的积分将在到期日失效，且不会自动续期。',
          '积分价格以购买时显示为准，我们可能进行调整。价格调整仅适用于未来购买，不影响已购积分。',
          '除法律另有规定外，已购积分不支持退款。如对某笔扣费有疑问，请联系我们，我们将进行核实。',
        ],
        items: [
          '你可随时在 Dashboard 查看积分余额与有效期。',
          '我们可能发放促销或奖励积分，此类积分可能附带发放时另行说明的条款。',
        ],
      },
      {
        heading: '6. 你的内容与参考图',
        body: [
          '你可以上传自己的照片（「你的内容」）与参考图。你保留对「你的内容」的所有权。上传即表示你授予 PhotoScope 一项有限的、非独占的、免版税许可，仅用于为提供与改进服务而处理、分析与存储该内容。',
          '你声明并保证：你拥有上传「你的内容」及任何参考图的权利，且它们不侵犯他人权利、不违反适用法律。',
        ],
      },
      {
        heading: '7. 可接受的使用',
        body: [
          '你同意仅将 PhotoScope 用于合法目的。尤其不得：',
        ],
        items: [
          '上传违法、侵权或有害内容，包括侵犯他人隐私或知识产权的图片。',
          '尝试逆向工程、干扰或超负荷本服务，或未经授权访问其系统。',
          '利用本服务构建竞争性产品，或以大规模方式抓取输出内容。',
        ],
      },
      {
        heading: '8. 知识产权',
        body: [
          'PhotoScope 的软件、设计、商标及分析成果（你本人的输入除外）归我们或我们的授权方所有。未经我们事先书面许可，你不得使用这些内容。',
          'AI 生成的解释、图表与建议仅供你个人学习与后期使用，不向你就任何参考图转移任何所有权。',
        ],
      },
      {
        heading: '9. AI 生成内容与免责声明',
        body: [
          'PhotoScope 使用人工智能生成解释、差距分析与调整建议。这些输出是基于视觉数据与摄影原理的引导，不构成专业的摄影、后期或任何其他专业建议。',
          '我们不保证任何建议都准确、完整或适用于你的特定照片与意图。你需对自己的后期决定，以及所创作或分享的最终图片负责。',
          '在法律允许的最大范围内，本服务按「原样」提供，不附带任何明示或暗示的担保。',
        ],
      },
      {
        heading: '10. 责任限制',
        body: [
          '在法律允许的最大范围内，PhotoScope 不对因使用本服务而产生的任何间接、偶然或后果性损害承担责任，包括数据丢失，或基于 AI 建议所作出的任何决定。',
        ],
      },
      {
        heading: '11. 终止',
        body: [
          '如你违反本条款或滥用本服务，我们可暂停或终止你的访问权限。你也可以随时停止使用 PhotoScope。终止后，你使用本服务的权利立即结束。',
        ],
      },
      {
        heading: '12. 条款变更',
        body: [
          '我们可能不时更新本条款，并在发布更新版本时标注新的生效日期。变更后继续使用即表示你接受更新后的条款。',
        ],
      },
      {
        heading: '13. 适用法律',
        body: [
          '本条款受美国法律管辖。任何争议均在美国法院解决。若你身处其他地区，仍须遵守当地法律。',
        ],
      },
      {
        heading: '14. 联系我们',
        body: [
          '对本条款有疑问？请联系 info@photoscope.cc。',
        ],
      },
    ],
  },
  privacy: {
    title: '隐私政策',
    effectiveDate: '生效日期：2024 年 3 月 15 日',
    intro:
      '本《隐私政策》说明 PhotoScope 收集哪些信息、如何使用，以及你拥有的选择权。PhotoScope 是一款 AI 视觉学习工具：你上传一张照片与一张参考图，我们分析两者之间的视觉差距，帮助你学习。',
    sections: [
      {
        heading: '1. 我们收集的信息',
        body: [],
        sub: [
          {
            heading: '1.1 账号信息',
            body: [
              '注册时，我们收集你的姓名、邮箱地址与账号资料。如你通过 Google 或其他服务商登录，我们会接收该服务商共享的账号标识与基本资料信息。',
            ],
          },
          {
            heading: '1.2 图片与参考图',
            body: [
              '我们收集你上传的照片及你选择的参考图，以及分析所需的技术元数据（如尺寸）。',
            ],
          },
          {
            heading: '1.3 使用与设备数据',
            body: [
              '我们收集你如何使用 PhotoScope 的信息，包括 IP 地址、浏览器类型、设备信息，以及你所使用功能的相关分析数据。这有助于我们运营并改进服务。',
            ],
          },
        ],
      },
      {
        heading: '2. 我们如何处理你的图片',
        body: [
          '为生成分析，你的图片会经过设备端技术（例如浏览器内的本地图像分析）处理，并在需要时经由云端 AI 服务处理。参考图仅用于计算你指定对比的视觉风格差距。',
          '我们仅将你的图片用于提供你请求的分析及维护你的历史记录。未经你另行同意，我们不会将你的个人照片用于训练公开模型。',
        ],
      },
      {
        heading: '3. 我们如何使用你的信息',
        body: [
          '我们将信息用于：',
        ],
        items: [
          '提供、运营并改进 PhotoScope。',
          '处理并分析你上传的图片。',
          '就账号、更新或支持事宜与你沟通。',
          '保障服务安全、防止滥用。',
        ],
      },
      {
        heading: '4. 信息共享与披露',
        body: [
          '我们不会出售你的个人信息。我们可能在以下情形共享：',
        ],
        items: [
          '为运营 PhotoScope 而合作的服务提供商，例如云托管、AI 处理与分析合作伙伴，并施加适当的安全措施。',
          '在法律要求时，或为保护我们与用户的权利时，向有关机关提供。',
          '无法识别你个人身份的聚合或匿名化数据，用于分析与产品改进。',
        ],
      },
      {
        heading: '5. Cookie 与跟踪技术',
        body: [
          '我们使用 Cookie 及类似技术来保持你的登录状态、记住偏好并了解使用情况。你可以在浏览器设置中管理 Cookie。',
        ],
      },
      {
        heading: '6. 数据安全',
        body: [
          '我们采用行业标准的措施保护你的信息。但没有任何系统绝对安全，请谨慎使用服务并妥善保管账号凭据。',
        ],
      },
      {
        heading: '7. 数据留存与删除',
        body: [
          '我们仅在必要期限内保留你的信息：',
        ],
        items: [
          '账号数据：在账号处于活跃状态期间保留。',
          '上传的图片与分析结果：为提供服务与你的历史记录而保留，并在你注销账号或提出删除请求时删除。',
          '你可联系我们要求删除数据。我们会在合理时间内处理经核实的请求。',
        ],
      },
      {
        heading: '8. 你的权利',
        body: [
          '根据你的所在地，你可能拥有访问、更正、删除或迁移个人数据的权利，并有权反对或退出特定处理。如需行使这些权利，请联系我们。我们将依据适用法律（如 GDPR 或 CCPA）作出回应。',
        ],
      },
      {
        heading: '9. 儿童隐私',
        body: [
          'PhotoScope 不面向 13 岁以下儿童。我们不会在知情的情况下收集 13 岁以下儿童的个人信息。',
        ],
      },
      {
        heading: '10. 国际数据传输',
        body: [
          'PhotoScope 可能在你所在国家（包括美国）之外的服务器上处理数据。在跨境传输个人数据时，我们会采取适当的保护措施。',
        ],
      },
      {
        heading: '11. 政策变更',
        body: [
          '我们可能不时更新本《隐私政策》，并发布标注新生效日期的版本。重大变更将通过网站告知。',
        ],
      },
      {
        heading: '12. 联系我们',
        body: [
          '对隐私有疑问？请联系 info@photoscope.cc。',
        ],
      },
    ],
  },
};
